
import React, { useState } from "react";
import bannerImage from "../img/aaaservices/lo.jpg"; // Update the path if needed


const BookingSection = () => {
 

  return (
    <div>
      {/* Parallax Header */}
      <section className="parallax-header">
        <div className="overlay" style={{ fontFamily:'Raqupine Regular',fontSize:'15px'}}>
          {/* <h5>Rixos Luxury Hotel</h5> */}
          <h1 className="banner-text">welcome to our hotels location</h1>
        </div>


        
      
      </section>

      {/* Booking Form */}
     

      {/* Internal CSS */}
      <style jsx>{`
        .parallax-header {
          background: url(${bannerImage}) no-repeat center center / cover;
          height: 400px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          text-align: center;
          margin-top:40px;
        }

        .overlay {
          background: rgba(0, 0, 0, 0.5);
          padding: 20px;
          color: #fff;
          width: 100%;
        }
           @keyframes textAppear {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
   
  }
}
  .overlay {
          background: rgba(0, 0, 0, 0.5);
          padding: 20px;
          color: #fff;
          width: 100%;
        }

         .booking-wrapper {
          display: flex;
          justify-content: center;
          position: relative;
          margin-top: 20px;
        }

        .booking-form {
          display: flex;
          background: rgba(255, 255, 255, 0.2);
          padding: 15px 15px 0px 15px;
          border-radius: 5px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
          gap: 15px;
          backdrop-filter: blur(10px);
           margin-top: 350px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-group label {
          font-size: 18px;
          // font-weight: bold;
         font-family: roboto;
         color: #ff9503;
        }

        .form-group input,
        .form-group select {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 5px;
          margin-top: 5px;
        }

        .btn-submit {
          background: #ff5a5f;
          color: white;
          border: none;
          padding: 10px 15px;
          cursor: pointer;
          border-radius: 30px;
          transition: 0.3s;
          width:131px;
          height:50px;
          margin-top: 25px;

        }
          .banner-text {
  font-size: 25px;
  font-weight: bold;
  color: white;
  text-align: center;
  position: absolute;
  animation: textAppear 1.5s ease-in-out forwards;
}

        .btn-submit:hover {
          background: #d4393e;
        }

       @media (max-width: 768px) {
  .booking-form {
     display: none;
  }
}
      `}</style>
    </div>
  );
};

export default BookingSection;
